import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TipoMovimientoDto } from '@models/tipos-movimiento/tipoMovimientoDto.model';
import { UpdateTipoMovimientoRequest } from '@models/tipos-movimiento/updateTipoMovimientoRequest.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TiposMoviemientoService } from '@services/tipos-movimiento/tipos-movimiento.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogCreateTipoMovimientoComponent } from '../crear-tipo-movimiento/dialog-create-tipo-movimiento/dialog-create-tipo-movimiento.component';

@Component({
  selector: 'app-actualizar-tipo-movimiento',
  templateUrl: './actualizar-tipo-movimiento.component.html',
  styleUrls: ['./actualizar-tipo-movimiento.component.css']
})
export class ActualizarTipoMovimientoComponent implements OnInit {

  formBuilder = new FormBuilder;
  form: any;
  tipoMovimientoDto!: TipoMovimientoDto
  get f() { return this.form.controls; }
  constructor(
    public dialogRef: MatDialogRef<DialogCreateTipoMovimientoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private tiposMoviemientoService: TiposMoviemientoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Resta: ["", Validators.compose([Validators.required,])],
      EsAnulable: ["", Validators.compose([Validators.required,])],
      TieneComision: ["", Validators.compose([Validators.required,])],
      // Sin required: un tipo sin icono es válido, la UI cae al genérico
      Icono: [null],
    })
  }

  ngOnInit(): void {
    this.getById(this.data.id)
  }

  doAction() {

    let updateTipoMovimientoRequest: UpdateTipoMovimientoRequest = new UpdateTipoMovimientoRequest
    updateTipoMovimientoRequest.id = this.data.id
    updateTipoMovimientoRequest.descripcion = this.form.controls["Descripcion"].value
    updateTipoMovimientoRequest.resta = this.form.controls["Resta"].value
    updateTipoMovimientoRequest.esAnulable = this.form.controls["EsAnulable"].value
    updateTipoMovimientoRequest.tieneComision = this.form.controls["TieneComision"].value
    updateTipoMovimientoRequest.icono = this.form.controls["Icono"].value
    updateTipoMovimientoRequest.editable = this.data.editable
    this.update(updateTipoMovimientoRequest)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  update(updateTipoMovimientoRequest: UpdateTipoMovimientoRequest) {
    this.spinner.show("spModificarTipoMovimiento")
    this.tiposMoviemientoService.update(updateTipoMovimientoRequest)
      .subscribe(
        data => {
          this.spinner.hide("spModificarTipoMovimiento")
          this.snackBar.showSuccess("Registro modificado correctamente.", "Exito");

          // Se devuelve lo editado para que quien abrió el diálogo refresque su copia
          // (ej: el buscador de tipo de movimiento, que lo tiene seleccionado).
          this.dialogRef.close({
            event: AccionesDialog.Modificar,
            data: updateTipoMovimientoRequest
          });
        },
        error => {
          this.spinner.hide("spModificarTipoMovimiento")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getById(id: number) {
    this.spinner.show("spModificarTipoMovimiento")
    this.tiposMoviemientoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spModificarTipoMovimiento")
          this.tipoMovimientoDto = data
          this.seteaForm(data)
        },
        error => {
          this.spinner.hide("spModificarTipoMovimiento")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  seteaForm(tipoMovimientoDto: TipoMovimientoDto) {
    this.form.controls["Descripcion"].setValue(tipoMovimientoDto.descripcion)
    this.form.controls["Resta"].setValue(tipoMovimientoDto.resta)
    this.form.controls["EsAnulable"].setValue(tipoMovimientoDto.esAnulable)
    this.form.controls["TieneComision"].setValue(tipoMovimientoDto.tieneComision)
    this.form.controls["Icono"].setValue(tipoMovimientoDto.icono)
  }

}
